module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA2klEQVQ4T2NkoDJgpLJ5DPQ38H9umygDC/M2sE/+/PVinFz1Gp+v8LoQbBgryz6G//91wIYwMl5h+P3HCZ+hOA3EMAzmLAKGYjUQxTCQAcguBLHxGIphIIZhv/84MbAwv4KGoRg8CHAYimIgNsNA4fW/sPM/OAj7yxlxqYGHCHKM/S/sPM3AwGCC7iVkA0Hq0cL3DGN/uSl2A4s6DzP8Z+BATx7oBsINBSUnRoYfjH3ltlgNxJW+sBmISy1ROWXUQLwF1ACFISg5gRI2UvKgKJZJKYSJ8jIpBgIAy0qWFUTr4DIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/up.png
// module id = XtJf
// module chunks = 1